import { render, staticRenderFns } from "./man_of_the_match.vue?vue&type=template&id=3c65c3f2&"
import script from "./man_of_the_match.vue?vue&type=script&lang=js&"
export * from "./man_of_the_match.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports